import { Dialog } from '@mui/material';
import { X } from 'feather-icons-react/build/IconComponents';
import { t } from 'i18next';
import { ButtonComponent } from '@shopeasy-dashboard-ui/ui-library';
import { Transition } from './Transition';

const UnsavedChangesModal = ({
  open = false,
  onStay,
  onLeave,
  title,
  message,
  leaveButtonText,
  stayButtonText,
}) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onStay}
      sx={{ zIndex: 9999999 }}
      aria-describedby='unsaved-changes-dialog-description'
    >
      <div className='w-full secondary-bg-color sm:w-[500px] p-6 rounded-[6px]'>
        <div className='flex text-primary items-center justify-between'>
          <p className='text-lg font-medium'>
            {title || t('lang_unsaved_changes', 'Unsaved changes')}
          </p>
          <button
            type='button'
            onClick={onStay}
            className='close-btn'
          >
            <X className='w-4 h-4' />
          </button>
        </div>
        <hr className='my-4 main-border-color' />
        <p className='text-base table-text'>
          {message ||
            t(
              'lang_unsaved_changes_desc',
              'You have unsaved changes. Do you want to leave and discard these changes, or stay on this page?',
            )}
        </p>
        <div className='flex items-center gap-3 mt-4'>
          <ButtonComponent variant='secondary' onClick={onLeave}>
            {leaveButtonText || t('lang_leave_page', 'Leave page')}
          </ButtonComponent>
          <ButtonComponent variant='primary' onClick={onStay}>
            {stayButtonText || t('lang_stay_on_page', 'Stay on page')}
          </ButtonComponent>
        </div>
      </div>
    </Dialog>
  );
};

export default UnsavedChangesModal;
